import { orderByDate } from "./utils";
import CanvasJSReact from "@canvasjs/react-charts";

export function getSPO2Layout(
  _datapointsSPO2,
  _datapointsHR,
  showTitle = true,
  small = false,
  includeHR = true,
) {
  const datapointsSPO2 = orderByDate(_datapointsSPO2);
  const datapointsHR = orderByDate(_datapointsHR);

  let layout = {
    theme: "light2",
    title: {
      text: showTitle
        ? `Grafico ultime ${datapointsSPO2.length} misurazioni`
        : "",
    },
    legend: {
      verticalAlign: "top",
      horizontalAlign: "center",
      dockInsidePlotArea: false,
    },
    tooltip: {
      shared: true,
    },
    axisY: {
      minimum: 20,
      gridThickness: 0.6,
      maximum: 140,
      interval: 20,
    },
    axisX: {
      labelFontSize: small ? 10 : 16,
      labelMaxWidth: small ? 45 : 60,
      stripLines: [],
      gridThickness: 0,
      labelTextAlign: "center",
      labelFormatter: function (e) {
        return CanvasJSReact.CanvasJS.formatDate(e.label, "DD/MM YYYY HH:mm");
      },
    },
    data: [
      {
        name: "SPO2 Media",
        type: "area",
        showInLegend: true,
        legendMarkerType: "square",
        color: "#888EE5",
        markerColor: "##888EF6",
        dataPoints: datapointsSPO2.map((el) => {
          return {
            label: el.x,
            y: el.y,
          };
        }),
      },
    ],
  };
  if (includeHR) {
    layout.data.push({
      name: "Freq. Cardiaca",
      type: "spline",
      showInLegend: true,
      legendMarkerType: "square",
      color: "#8e5948",
      lineColor: "#8e5948",
      dataPoints: datapointsHR.map((el) => {
        return {
          label: el.x,
          y: el.y,
        };
      }),
    });
  }

  return layout;
}

export function generateSPO2Chart(reports, small = false, includeHR = true) {
  const { datapointsSPO2, datapointsHR } = parseSPO2Reports(reports);

  // genero il report
  const layout = getSPO2Layout(
    datapointsSPO2,
    datapointsHR,
    false,
    small,
    includeHR,
  );
  return layout;
}

export function parseSPO2Reports(measures) {
  let datapointsSPO2 = [];
  let datapointsHR = [];

  // prendo le misurazioni di pressioni/hr + data
  measures.forEach((report, index) => {
    if (
      report.data.SPO2 !== null &&
      report.data.SPO2 !== undefined &&
      report.data.HR !== null &&
      report.data.HR !== undefined
    ) {
      datapointsSPO2.push({
        x: report.data.Date,
        y: eval(report.data.SPO2),
      });

      datapointsHR.push({
        x: report.data.Date,
        y: eval(report.data.HR),
      });
    }
  });

  return {
    datapointsSPO2: datapointsSPO2,
    datapointsHR: datapointsHR,
  };
}
